const errors = [
  {
    name: "Error404",
    path: "/error404",
    component: () => import(`../views/Errors/Error404`)
  }
]

export default {
  errors
}